import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfSynthesisJobRetryDialog } from '@Pages/RetroSynthesis/SynthesisJobRetry/constants';

// eslint-disable-next-line import/prefer-default-export
export const openSynthesisJobRetryDialog = (project, status, type, onRetry) =>
  updateDialog({
    id: typeOfSynthesisJobRetryDialog,
    dialogType: typeOfSynthesisJobRetryDialog,
    project,
    status,
    type,
    onRetry,
  });
